import { defineMessages } from 'react-intl';

export default defineMessages({
    agmHeading: {
        id: 'custom.views.agm.heading',
        defaultMessage: 'Annual General Meeting Materials'
    },
    myPreferences: {
        id: 'portal.index.My Preferences',
        defaultMessage: 'My Preferences'
    },
    preferences: {
        id: 'custom.views.agm.My AGM',
        defaultMessage: 'My AGM'
    },
    likesToReceiveAgmMaterials: {
        id: 'custom.views.agm.Would you like to receive AGM Materials?',
        defaultMessage: 'Would you like to receive the Heartland Farm Mutual Annual General Meeting (AGM) Materials?'
    },
    selectMethodOfReceiveAgm: {
        id: 'custom.views.agm.Select method of receiving the materials:',
        defaultMessage: 'Select method of receiving the materials:'
    },
    modeEmail: {
        id: 'custom.views.agm.Email',
        defaultMessage: 'Email'
    },
    modePost: {
        id: 'custom.views.agm.Post',
        defaultMessage: 'Canada Post'
    },
    saveChanges: {
        id: 'custom.views.agm.Save Changes',
        defaultMessage: 'Save Changes'
    },
    saveSuccess: {
        id: 'custom.views.agm.AGM details are successfully updated.',
        defaultMessage: 'AGM details are successfully updated'
    },
    saveError: {
        id: 'custom.views.agm.Failed to update details.',
        defaultMessage: 'Failed to update details, please try again later.'
    },
    saveAuthorityError: {
        id: 'custom.views.agm.User does not have authority to edit account details.',
        defaultMessage: 'User does not have authority to edit account details'
    },
    policyDocsConsent: {
        id: 'custom.views.preferences.PolicyConsent',
        defaultMessage: 'I agree to receive emails from Heartland Farm Mutual Insurance and/or Kings Mutual Insurance regarding my policy documents.'
    }
});
